(() => {
"use strict";
	function initSideNav() {
		const openNavBtn = document.querySelector(".open-nav-btn");
		const closeNavBtn = document.querySelector(".side-nav__close-btn");
		const sideNav = document.querySelector(".side-nav");
		const overlay = document.querySelector(".side-nav-overlay");

		function openNav() {
			sideNav.style.left = "0";
			overlay.style.opacity = "1";
			overlay.style.pointerEvents = "auto";
			openNavBtn.setAttribute('aria-expanded', 'true');
			closeNavBtn.setAttribute('aria-expanded', 'true');
		}

		function closeNav() {
			sideNav.style.left = "-52.8rem";
			overlay.style.opacity = "0";
			overlay.style.pointerEvents = "none";
			openNavBtn.setAttribute('aria-expanded', 'false');
			closeNavBtn.setAttribute('aria-expanded', 'false');
		}

		openNavBtn.addEventListener("click", openNav);
		closeNavBtn.addEventListener("click", closeNav);
		overlay.addEventListener("click", closeNav);

	}


	function initSideNavMenus() {
		const menuButtons = document.querySelectorAll('.side-nav__menu-btn');
		for (const button of menuButtons) {
			button.addEventListener('click', (e) => {
				e.currentTarget.classList.toggle('active');
				const menuContent = button.nextElementSibling;
				menuContent.style.maxHeight = menuContent.style.maxHeight ? null : menuContent.scrollHeight + 'px';
			});
		}

		const submenuButtons = document.querySelectorAll('.side-nav__submenu-btn');
		for (const button of submenuButtons) {
			button.addEventListener('click', (e) => {
				e.currentTarget.classList.toggle('active');
				const submenuContent = button.nextElementSibling;
				submenuContent.style.maxHeight = submenuContent.style.maxHeight ? null : submenuContent.scrollHeight + 'px';

				const parentMenuContent = button.closest('.side-nav__menu-content');
				if (submenuContent.style.maxHeight) {
					parentMenuContent.style.maxHeight = (parseInt(parentMenuContent.style.maxHeight) || parentMenuContent.scrollHeight) + submenuContent.scrollHeight + 'px';

				} else {
					parentMenuContent.style.maxHeight = (parseInt(parentMenuContent.style.maxHeight) || parentMenuContent.scrollHeight) - submenuContent.scrollHeight + 'px';
				}
			});
		}
	}

	initSideNav();
	initSideNavMenus();


})();